import { ShoppingBag } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BottomActionBarProps {
  /** `origin` is the button that was tapped: the fly-to-cart thumbnail takes off from it */
  onAddToCart?: (origin: HTMLElement) => void;
  onBuyNow?: () => void;
  className?: string;
}
const BottomActionBar = ({ onAddToCart, onBuyNow, className = '' }: BottomActionBarProps) => {
  return (
    <div
      className={cn(
        'flex w-full fixed bottom-0 inset-x-0 p-6 bg-white z-10 mx-auto max-w-full lg:max-w-[60%] md:max-w-[80%]  items-center gap-3 ',
        className
      )}
    >
      <button
        type="button"
        onClick={(event) => onAddToCart?.(event.currentTarget)}
        aria-label="Tambah ke keranjang"
        className="relative flex h-[51px] w-[51px] shrink-0 items-center justify-center rounded-[8px] border border-blue-cs-200 bg-white text-[#007AFF] transition hover:bg-[#F3F8FF]"
      >
        <ShoppingBag size={25} strokeWidth={1.8} />

        <span className="absolute -right-[7px] -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-text-blue-100 text-white">
          +
        </span>
      </button>

      <button type="button" onClick={onBuyNow} className="flex-1 body1medium btn-fill-blue">
        Beli Sekarang
      </button>
    </div>
  );
};

export default BottomActionBar;
